"use client";
import s from "./index.es59.js";
import "./index.es9.js";
import l, { useId as c } from "react";
import d from "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import b from "./index.es63.js";
import "./index.es14.js";
import "./index.es15.js";
const v = s.div`
  .bl-multiselect__children {
    z-index: 5;
  }
`, k = ({
  choices: o,
  values: t,
  btnText: i,
  label: a,
  onChange: r
}) => {
  const n = c(), m = (e) => () => {
    t.includes(e) ? r(t.filter((u) => u !== e)) : r([...t, e]);
  }, p = typeof i == "string" ? i : i({ choices: o, values: t });
  return /* @__PURE__ */ l.createElement(v, null, /* @__PURE__ */ l.createElement(
    b,
    {
      buttonText: p,
      label: a,
      buttonId: "button-" + n,
      listboxId: "listbox" + n
    },
    /* @__PURE__ */ l.createElement("div", { className: "bl-grid bl-grid--three-columns bl-grid--small-row-gap" }, o.map((e) => /* @__PURE__ */ l.createElement(
      d,
      {
        key: `peer-input-${e.value}`,
        inputId: `peer-input-${e.value}`,
        label: e.display,
        isChecked: t.includes(e.value),
        onChange: m(e.value)
      }
    )))
  ));
};
export {
  k as default
};
//# sourceMappingURL=index.es23.js.map
